import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { DetenteurComponent } from './modal/detenteur/detenteur.component';
import { SuiviComponent } from './modal/suivi/suivi.component';
import { PieceClientComponent } from './tab/piece-client/piece-client.component';
import { RapportClientComponent } from './tab/rapport-client/rapport-client.component';
import { CommentaireDossierComponent } from './tab/commentaire-dossier/commentaire-dossier.component';
import { SuiviDossierComponent } from './tab/suivi-dossier/suivi-dossier.component';
import { FormCommentaireSimpleComponent } from './form/form-commentaire-simple/form-commentaire-simple.component';
import { UploadInPieceComponent } from './modal/upload-in-piece/upload-in-piece.component';
import { UploadInRapportComponent } from './modal/upload-in-rapport/upload-in-rapport.component';
import { FormAffectationDossierComponent } from './form/form-affectation-dossier/form-affectation-dossier.component';
import { FormEmissionAvisDossierComponent } from './form/form-emission-avis-dossier/form-emission-avis-dossier.component';
import { FormAjouterRapportAnalyseComponent } from './form/form-ajouter-rapport-analyse/form-ajouter-rapport-analyse.component';
import { FormAccepterConditionComponent } from './form/form-accepter-condition/form-accepter-condition.component';
import { FormAnalyseDossierEmissionAvisComponent } from './form/form-analyse-dossier-emission-avis/form-analyse-dossier-emission-avis.component';
import { FormSignerRapportAnalyseComponent } from './form/form-signer-rapport-analyse/form-signer-rapport-analyse.component';
import { FormCheckListModalComponent } from './modal/form-check-list-modal/form-check-list-modal.component';
import { RetournerDossierModalComponent } from './modal/retourner-dossier-modal/retourner-dossier-modal.component';
import { PieceClientUpdateComponent } from './tab/piece-client-update/piece-client-update.component';
import { RapportClientUpdateComponent } from './tab/rapport-client-update/rapport-client-update.component';
import { ImageViewerModalComponent } from './modal/viewer/image-viewer-modal/image-viewer-modal.component';
import { OfficeViewerModalComponent } from './modal/viewer/office-viewer-modal/office-viewer-modal.component';
import { ReportViewerModalComponent } from './modal/viewer/report-viewer-modal/report-viewer-modal.component';
import { PdfViewerModalComponent } from './modal/viewer/pdf-viewer-modal/pdf-viewer-modal.component';
import { DocViewerModalComponent } from './modal/viewer/doc-viewer-modal/doc-viewer-modal.component';
import { RenommerFichierComponent } from './modal/renommer-fichier/renommer-fichier.component';
import { RemplacerFichierComponent } from './modal/remplacer-fichier/remplacer-fichier.component';
import { FormAnalyseDossierComponent } from './form/form-analyse-dossier/form-analyse-dossier.component';
import { UpdateInfoIndividualComponent } from './modal/particulier/update-info-individual/update-info-individual.component';
import { UpdatePieceIndividualComponent } from './modal/particulier/update-piece-individual/update-piece-individual.component';
import { UpdateEmploiIndividualComponent } from './modal/particulier/update-emploi-individual/update-emploi-individual.component';
import { UpdateFinanceIndividualComponent } from './modal/particulier/update-finance-individual/update-finance-individual.component';
import { DemanderSignatureModalComponent } from './modal/demander-signature-modal/demander-signature-modal.component';
import { UploadInGarantieComponent } from './modal/upload-in-garantie/upload-in-garantie.component';
import { AbandonnerDossierComponent } from './modal/abandonner-dossier/abandonner-dossier.component';
import { ReactiverDossierComponent } from './modal/reactiver-dossier/reactiver-dossier.component';
import { ChangerInitiateurDossierComponent } from './modal/changer-initiateur-dossier/changer-initiateur-dossier.component';
import { AssignerDossierComponent } from './modal/assigner-dossier/assigner-dossier.component';
import { TrouverEmployeeModalComponent } from './modal/trouver-employee-modal/trouver-employee-modal.component';
import { CorrespondreDossierModalComponent } from './modal/correspondre-dossier-modal/correspondre-dossier-modal.component';
import { FormAvisClientComponent } from './form/form-avis-client/form-avis-client.component';
import { FormPreparationComiteInterneCreditComponent } from './form/form-preparation-comite-interne-credit/form-preparation-comite-interne-credit.component';
import { FormAjoutGarantieComponent } from './form/form-ajout-garantie/form-ajout-garantie.component';
import { ItemDetailComponent } from './form/form-ajout-garantie/item-detail/item-detail.component';
import { AddGarantieDetailComponent } from './form/form-ajout-garantie/add-garantie-detail/add-garantie-detail.component';
import { AddDocumentGarantieComponent } from './form/form-ajout-garantie/add-document-garantie/add-document-garantie.component';
import { EditGarantieDetailComponent } from './form/form-ajout-garantie/edit-garantie-detail/edit-garantie-detail.component';
import { ScoringComponent } from './tab/scoring/scoring.component';
import { AddControlByRequestComponent } from './modal/control-by-request/add-control-by-request/add-control-by-request.component';
import { EditControlByRequestComponent } from './modal/control-by-request/edit-control-by-request/edit-control-by-request.component';
import { FormEmissionAccordDossierComponentComponent } from './form/form-emission-accord-dossier-component/form-emission-accord-dossier-component.component';
import { FormPreparationComiteSuperieurCreditComponent } from './form/form-preparation-comite-superieur-credit/form-preparation-comite-superieur-credit.component';
import { FormAjoutRapportEmissionAvisComponent } from './form/form-ajout-rapport-emission-avis/form-ajout-rapport-emission-avis.component';
import { FormSignerRapportEmissionAvisComponent } from './form/form-signer-rapport-emission-avis/form-signer-rapport-emission-avis.component';
import { FormAssignerGroupDossierComponent } from './modal/form-assigner-group-dossier/form-assigner-group-dossier.component';
import { DiagramBpmnComponent } from './modal/diagram-bpmn/diagram-bpmn.component';
import { LogAssignationComponent } from './modal/log-assignation/log-assignation.component';
import { ChangerEtapeComponent } from './modal/changer-etape/changer-etape.component';
import { TacheDetailComponent } from './modal/tache-detail/tache-detail.component';
import { UpdateInfoEntrepriseComponent } from './modal/entreprise/update-info-entreprise/update-info-entreprise.component';
import { InfoComplementaireComponent } from './tab/info-complementaire/info-complementaire.component';
import { FormComplementDossierEntrepriseComponent } from './form/form-complement-dossier-entreprise/form-complement-dossier-entreprise.component';
import { EditClientComponent } from './modal/entreprise/edit-client/edit-client.component';
import { AddClientComponent } from './modal/entreprise/add-client/add-client.component';
import { AddFournisseurComponent } from './modal/entreprise/add-fournisseur/add-fournisseur.component';
import { EditFournisseurComponent } from './modal/entreprise/edit-fournisseur/edit-fournisseur.component';
import { PdfCdnViewerComponent } from './modal/viewer/pdf-cdn-viewer/pdf-cdn-viewer.component';
import { MigrerDossierComponent } from './modal/migrer-dossier/migrer-dossier.component';
import { DemanderESignatureComponent } from './modal/demander-esignature/demander-esignature.component';
import { FormAjoutRapportAcceptationComponent } from './form/form-ajout-rapport-acceptation/form-ajout-rapport-acceptation.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],

  declarations: [
    DetenteurComponent,
    SuiviComponent,
    PieceClientComponent,
    RapportClientComponent,
    CommentaireDossierComponent,
    SuiviDossierComponent,
    FormCommentaireSimpleComponent,
    UploadInPieceComponent,
    UploadInRapportComponent,
    FormAffectationDossierComponent,
    FormEmissionAvisDossierComponent,
    FormAjouterRapportAnalyseComponent,
    FormAccepterConditionComponent,
    FormAnalyseDossierEmissionAvisComponent,
    FormSignerRapportAnalyseComponent,
    FormCheckListModalComponent,
    RetournerDossierModalComponent,
    PieceClientUpdateComponent,
    RapportClientUpdateComponent,
    ImageViewerModalComponent,
    OfficeViewerModalComponent,
    ReportViewerModalComponent,
    PdfViewerModalComponent,
    DocViewerModalComponent,
    RenommerFichierComponent,
    RemplacerFichierComponent,
    FormAnalyseDossierComponent,
    UpdateInfoIndividualComponent,
    UpdatePieceIndividualComponent,
    UpdateEmploiIndividualComponent,
    UpdateFinanceIndividualComponent,
    DemanderSignatureModalComponent,
    UploadInGarantieComponent,
    AbandonnerDossierComponent,
    ReactiverDossierComponent,
    ChangerInitiateurDossierComponent,
    AssignerDossierComponent,
    TrouverEmployeeModalComponent,
    CorrespondreDossierModalComponent,
    FormAvisClientComponent,
    FormPreparationComiteInterneCreditComponent,
    FormAjoutGarantieComponent,
    ItemDetailComponent,
    AddGarantieDetailComponent,
    AddDocumentGarantieComponent,
    EditGarantieDetailComponent,
    ScoringComponent,
    AddControlByRequestComponent,
    EditControlByRequestComponent,
    FormEmissionAccordDossierComponentComponent,
    FormPreparationComiteSuperieurCreditComponent,
    FormAjoutRapportEmissionAvisComponent,
    FormSignerRapportEmissionAvisComponent,
    FormAssignerGroupDossierComponent,
    DiagramBpmnComponent,
    LogAssignationComponent,
    ChangerEtapeComponent,
    TacheDetailComponent,
    UpdateInfoEntrepriseComponent,
    InfoComplementaireComponent,
    FormComplementDossierEntrepriseComponent,
    EditClientComponent,
    AddClientComponent,
    AddFournisseurComponent,
    EditFournisseurComponent,
    PdfCdnViewerComponent,
    MigrerDossierComponent,
    DemanderESignatureComponent,
    FormAjoutRapportAcceptationComponent
  ],

  entryComponents: [
    DetenteurComponent,
    SuiviComponent,
    UploadInPieceComponent,
    UploadInRapportComponent,
    FormCheckListModalComponent,
    RetournerDossierModalComponent,
    ImageViewerModalComponent,
    OfficeViewerModalComponent,
    ReportViewerModalComponent,
    PdfViewerModalComponent,
    DocViewerModalComponent,
    PdfCdnViewerComponent,
    RenommerFichierComponent,
    RemplacerFichierComponent,
    UpdateInfoIndividualComponent,
    UpdatePieceIndividualComponent,
    UpdateEmploiIndividualComponent,
    UpdateFinanceIndividualComponent,
    DemanderSignatureModalComponent,
    UploadInGarantieComponent,
    AbandonnerDossierComponent,
    ReactiverDossierComponent,
    ChangerInitiateurDossierComponent,
    AssignerDossierComponent,
    TrouverEmployeeModalComponent,
    CorrespondreDossierModalComponent,
    ItemDetailComponent,
    AddGarantieDetailComponent,
    AddDocumentGarantieComponent,
    EditGarantieDetailComponent,
    AddControlByRequestComponent,
    EditControlByRequestComponent,
    FormAssignerGroupDossierComponent,
    DiagramBpmnComponent,
    LogAssignationComponent,
    ChangerEtapeComponent,
    TacheDetailComponent,
    UpdateInfoEntrepriseComponent,
    EditClientComponent,
    AddClientComponent,
    AddFournisseurComponent,
    EditFournisseurComponent,
    MigrerDossierComponent,
    DemanderESignatureComponent
  ],

  providers: [
  ],

  exports: [
    PieceClientComponent,
    RapportClientComponent,
    CommentaireDossierComponent,
    SuiviDossierComponent,
    PieceClientUpdateComponent,
    RapportClientUpdateComponent,
    UploadInGarantieComponent,
    ScoringComponent,
    InfoComplementaireComponent
  ]

})
export class FormulaireModule { }
